import {
  STORE_CRM_FILTERS,
  CLEAR_CRM_FILTERS,
} from '@/store/actions/crmFilters';
import { AUTH_LOGOUT } from '@/store/actions/auth';

const CRM_FILTERS_KEY = 'CRM_FILTERS';

const actions = {
  [STORE_CRM_FILTERS]: ({ commit }, filters) => {
    localStorage.setItem(CRM_FILTERS_KEY, JSON.stringify(filters));
    commit(STORE_CRM_FILTERS, filters);
  },
  [CLEAR_CRM_FILTERS]: ({ commit }) => {
    localStorage.removeItem(STORE_CRM_FILTERS);
    commit(STORE_CRM_FILTERS, null);
  },
};

const getters = {
  isNeedConfirmCrmFilters: (state) => state.filters !== null,
  getCrmFilters: (state) => state.filters,
};

const mutations = {
  [STORE_CRM_FILTERS]: (state, filters) => {
    state.filters = filters;
  },
  [AUTH_LOGOUT]: (state) => {
    state.filters = null;
  },
};

const state = () => ({
  filters: null,
});

export default () => ({
  actions,
  getters,
  mutations,
  state,
});
